export default [
  {
    title: 'Usuario',
    icon: 'UserIcon',
    permisos: ['usu_usuario_consultar', 'usu_rol_consultar'],
    children: [
      {
        title: 'Roles',
        route: 'rol',
        icon: 'UserCheckIcon',
        permiso: 'usu_rol_consultar',
      },
      {
        title: 'Usuarios',
        route: 'usuario',
        icon: 'UsersIcon',
        permiso: 'usu_usuario_consultar',
      },
      {
        title:'Personas',
        route:'consultar_personas',
        icon: 'UsersIcon',
        permiso: 'per_consultar_persona'
      }
    ],
  },
]
